export function Icon({ height, width, color }: any) {
    return (
        <svg width={width || '100%'} height={height || '100%'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
            <g id="Layer_28" >
                <path fill={color} d="M57,6H7A1,1,0,0,0,6,7V57a1,1,0,0,0,1,1H36.59a1,1,0,0,0,1-1V39.92a1,1,0,0,0-2,0V56H8V40.92H26.89a1,1,0,0,0,1-1V30.54a1,1,0,0,0-2,0v8.38H8V22H26.89a1,1,0,0,0,1-1V8H38.71v6.92a1,1,0,1,0,2,0V8H56V22.88H39.71a1,1,0,0,0,0,2H56v14H45.33a1,1,0,0,0,0,2H56V56H47a1,1,0,0,0,0,2H57a1,1,0,0,0,1-1V7A1,1,0,0,0,57,6ZM25.89,20H8V8H25.89Z" />
            </g>
        </svg>
    );
}